<template>
  <div class="page">
    <a-card title="H5移动端" :bordered="false" :bodyStyle="{padding:'0px'}"
            :headStyle="{borderBottom:'0px',fontSize:'18px'}">
      <a-card class="install-ly" title="基本信息" :bordered="false" :headStyle="{borderBottom:'0px'}">
        <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                      :label-col="currentFormLayout.labelCol"
                      :wrapper-col="currentFormLayout.wrapperCol">
          <a-form-model-item label="H5移动端地址">
            <span>{{ h5HomeUrl }}</span>
            <a style="margin-left:15px;" @click="onCopy">复制</a>
          </a-form-model-item>
          <a-form-model-item label="平台二维码">
            <!-- 二维码下载组件 -->
            <QrCodeModule></QrCodeModule>
          </a-form-model-item>
          <template v-if="isCheck">
            <a-form-model-item label="域名绑定" prop="domain">
              <a-input placeholder="不需要加http://前缀" v-model="ruleForm.domain" :disabled="isDisabled"/>
              <div class="line-text">请在域名解析平台添加该域名A记录，例如IP绑定192.168.1.1 <br/>域名需在工信部完成备案，且备案主体与当前后台认证主体一致
              </div>
            </a-form-model-item>
            <a-form-model-item label="域名备案号" prop="registrationNumber">
              <a-input placeholder="如粤ICP备16010228号-1" v-model="ruleForm.registrationNumber"
                       :disabled="isDisabled"/>
            </a-form-model-item>
            <a-form-model-item label="域名SSL证书" required>
              <a-upload
                :action="uploadFileUrl"
                :multiple="false"
                :file-list="fileList"
                @change="handleChange"
                :beforeUpload="beforeUpload"
                :remove="handleRemove"
              >
                <a-button>
                  <a-icon type="upload"/>
                  上传文件
                </a-button>
                <span class="pl10">请上传证书压缩包支持.zip格式</span>
              </a-upload>
              <div class="tips-text" v-if="ruleForm.expireTime">当前证书 <span>{{ ruleForm.expireTimeStr }}</span>到期，请在到期前15天内上传新证书，以免造成无法访问等严重问题
              </div>
            </a-form-model-item>
            <a-form-model-item label="管理人手机号" required>
              <a-input placeholder="请输入管理人手机号" v-model="merchantMobile" disabled/>
              <a-tooltip placement="topLeft"
                         title="管理人手机号即主账号登录手机号，如有更改需求，请“设置-安全设置”中修改">
                <a-icon type="exclamation-circle" style="margin-left:10px;"/>
              </a-tooltip>
            </a-form-model-item>
            <a-form-model-item label="验证码" prop="smsCode">
              <a-input placeholder="请输入验证码" v-model="ruleForm.smsCode" style="max-width:280px;"/>
              <a-button v-if="!isShow" style="margin-left:20px;" :disabled="isGetCode" @click="onEventCode">获取验证码
              </a-button>
              <a-button v-else style="margin-left:20px;"> ({{ countDown }}s)后重新获取</a-button>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
            </a-form-model-item>
          </template>
        </a-form-model>
      </a-card>
    </a-card>
  </div>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import QrCodeModule from '../component/QrCodeModule'
import moment from 'moment'

export default {
  name: 'MovePort',
  mixins: [ruleFormMixins],
  components: {
    QrCodeModule
  },
  data() {
    return {
      isShow: false,
      timer: null,
      countDown: '',
      fileList: [],
      uploadFileUrl: this.getUploadFileUrl(),
      h5HomeUrl: '',
      submitLoading: false,
      isCheck: false,
      isDisabled: false,
      merchantId: this.$store.getters.userInfo.merchantId,
      merchantMobile: this.getSubstr(this.$store.getters.userInfo.mobile),
      ruleForm: {
        domain: '',//域名
        expireTime: '',//过期时间 ,
        id: 0,//商户id
        registrationNumber: '',//备案号
        smsCode: '',//手机短信验证码 ,
        sslUrl: '',//ssl证书地址 ,
        status: 0//状态
      },
      rules: {
        domain: [
          { required: true, message: '请输入域名', trigger: 'blur' },
          {
            pattern: /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/,
            message: '请输入正确的域名',
            trigger: 'blur'
          }
        ],
        registrationNumber: [
          { required: true, message: '请输入域名备案号', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ]
      },
      submitFormData: '',
      platformId: this.getPlatformConfig().platformId,
      isGetCode: false
    }
  },
  mounted() {
    this.getHomeUrlInfo()
    this.getHomeCheck()
  },
  destroyed() {
    this.clearFun()
  },
  methods: {
    //获取图片上传地址
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    getSubstr(value) {
      if (value) {
        return value.substring(0, 3) + '****' + value.substring(value.length - 4)
      }
    },
    handleChange(info) {
      this.getLogUtils().logWithTag('handleChange', info)
      if (info.file.status && info.file.status != 'removed') {
        let fileList = [...info.fileList]
        fileList = fileList.slice(-1)
        fileList = fileList.map(file => {
          if (file.response) {
            file.url = file.response.data
          }
          return file
        })
        this.fileList = fileList
        this.getLogUtils().logWithTag('handleChange', this.fileList)
        if (this.fileList.length > 0) {
          this.ruleForm.sslUrl = this.getUrlFromFileList(this.fileList)
        } else {
          this.ruleForm.sslUrl = ''
        }
      }
      this.getLogUtils().logWithTag('sslUrl', this.ruleForm.sslUrl)
    },
    // 附件上传
    // handleChange({fileList}) {
    //   this.getLogUtils().logWithTag('handleChange', fileList)
    //   this.fileList = fileList.slice(-1);
    //   this.fileList = this.fileList.map(file => {
    //     if (file.response) {
    //       file.url = file.response.data;
    //     }
    //     return file;
    //   });
    //   this.getLogUtils().logWithTag('图片上传成功', this.fileList)
    //   if(this.fileList.length>0){
    //     this.ruleForm.sslUrl = this.getUrlFromFileList(this.fileList);
    //   }else{
    //     this.ruleForm.sslUrl = "";
    //   }
    //   this.getLogUtils().logWithTag('sslUrl',this.ruleForm.sslUrl)
    // },
    getUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        if (fileList[0] && fileList[0].response) {
          return fileList[0].response.data
        }
      }
      return ''
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.getLogUtils().logWithTag('图片删除成功', this.fileList)
    },
    beforeUpload(file) {
      this.getLogUtils().logWithTag('beforeUpload', file)
      // 限制图片 格式、size、分辨率
      // const isPDF = file.type === 'application/x-zip-compressed';
      // const isZIP = file.type === 'application/zip';
      let extensionsName = file.name.substring(file.name.lastIndexOf('.') + 1)
      this.getLogUtils().logWithTag('extensionsName', extensionsName)
      const extension = extensionsName === 'zip'
      if (!extension) {
        this.$message.error('请上传证书压缩包支持.zip格式')
        return false
      }
      // if (!isPDF&&!isZIP) {
      //   this.$message.error('请上传证书压缩包支持.zip格式')
      //   return false
      // }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M')
        return false
      }
      return true
    },
    onCopy() {
      // get current settings from mixin or this.$store.state.app, pay attention to the property name
      this.$copyText(this.h5HomeUrl).then(message => {
        this.getLogUtils().logWithTag('copy', message)
        this.$message.success('复制完毕')
      }).catch(err => {
        this.getLogUtils().logWithTag('copy.err', err)
        this.$message.error('复制失败')
      })
    },
    // 获取数据
    getHomeUrlInfo() {
      this.getHttpServices().getUserService().get('homepage/H5/get/urlInfo?platformId=' + this.platformId).then(res => {
        this.getLogUtils().logWithTag('==getHomeUrlInfo==', res)
        this.h5HomeUrl = res.homePageUrl
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onEventCode() {
      this.getHttpServices().getBaseService().post('sms/verification', {
        effect: 8,
        mobile: this.$store.getters.userInfo.mobile,
        userType: 1
      }).then(res => {
        this.getLogUtils().logWithTag('==onEventCode==', res)
        this.getCode()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getCode() {
      let NUM_SECOND = 30
      if (!this.timer) {
        this.countDown = NUM_SECOND
        this.isShow = true
        this.timer = setInterval(() => {
          if (this.countDown > 0 && this.countDown <= NUM_SECOND) {
            this.countDown--
            this.getCode()
          } else {
            this.clearFun()
          }
        }, 1000)
      }
    },
    clearFun() {
      clearInterval(this.timer)
      this.timer = null
      this.countDown = ''
      this.isShow = false
    },

    // 检测用户是否拥有自有支付服务
    getHomeCheck() {
      this.getHttpServices().getUserService().get('homepage/H5/check?merchantId=' + this.merchantId + '&platformId=' + this.platformId).then(res => {
        this.getLogUtils().logWithTag('==getHomeCheck==', res)
        this.isCheck = res
        if (res == true) {
          this.getDetail()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取域名+备案
    getDetail() {
      this.getHttpServices().getUserService().get('homepage/H5/detail?platformId=' + this.platformId).then(res => {
        this.getLogUtils().logWithTag('==getDetail==', res)
        if (res) {
          this.ruleForm = res
          if (res.id) {
            this.isDisabled = true
            this.isGetCode = this.checkExpirationTime(res.expireTime, res.expireTimeStr)
          }
          if (res.sslUrl) {
            this.fileList = [{
              uid: '-1',
              name: res.sslUrl,
              status: 'done',
              url: res.sslUrl
            }]
          } else {
            this.fileList = []
          }
        } else {
          this.isDisabled = false
          this.isGetCode = false
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    checkExpirationTime(expireTime, expireTimeStr) { //比较时间，返回Boolean
      let falg = true
      let date = moment(new Date()).format('YYYY-MM-DD')
      if (expireTime) {
        if (expireTimeStr) {
          let calculationDate = this.getDateHelper().diffDays(date, expireTimeStr)
          if (calculationDate <= 15) {
            falg = false
          }
        }
      }
      return falg
    },
    checkForm() {
      if (this.fileList.length < 1) {
        this.$message.error('请上传证书压缩包')
        return false
      }
      return true
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.ruleForm.platformId = this.platformId
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('submitFormData', this.submitFormData)
      this.getHttpServices().getUserService().post('homepage/H5/submit', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('保存成功')
        setTimeout(() => {
          this.isDisabled = true
          this.isGetCode = true
          this.ruleForm.smsCode = ''
        }, 1500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    }
  }

}
</script>
<style lang="less">
@import url('../../CustomPage.less');

.line-text {
  line-height: 20px;
  color: rgba(51, 51, 51, 0.560784);
  font-size: 13px;
}

.pl10 {
  padding-left: 10px;
}

.tips-text {
  line-height: 20px;
  color: rgba(51, 51, 51, 0.560784);
  font-size: 13px;

  span {
    color: #f5222d;
  }
}
</style>